import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-batch-info-list',
  templateUrl: './batch-info-list.component.html',
  styleUrls: ['./batch-info-list.component.css']
})
export class BatchInfoListComponent implements OnInit {

  batchInfoList: any = []
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  singleBatchInfo: any = []
  isAdd: boolean = false
  isEdit: boolean = false
  isViewMode: boolean = false
  isRefresh: boolean = false
  oldBatchPrice: any = ""
  viewData: any = null;
  deleteBatchInfoId: any = ""
  initialize: any = 0;
  lastSized: any = 5;
  first: number = 0;
  isLoading: any = false
  searchFilter: any = "";



  cid: any;
  form: any | FormGroup;
  uomData: any = []
  priceInput = ""
  uomInput = ""
  selectedIndex = 0
  supportedUOMObjList: any = []
  row: any = [
    {
      chargeName: '',
      isPercentage: false,
      baseCharge: '',
      baseLabel: 'Base',
      prices: [
        {
          "qty": "",
          "uom": "",
          "cPrice": "",
          "priceLabel": "Price",
          "value": "",
          "totalValue": "",
          "individualCharge": false
        }
      ]
    }
  ];

  totalValue: any = []
  totalProfitValue: any = []
  extraRow: any = []
  totalExtraValue: any = []
  formulaName = ""
  batchName = ""
  batchQty = ""
  batchPrice = ""
  batchUOM = ""
  productCompositioncList: any = []
  singleproductCompositionData: any = []
  profitValue: any = []
  salesChargeValue: any = []
  totalSalesChargeValue: any = []

  actionControls: any = {
    isAdd: false,
    isView: false,
    isDelete: false,
    isModify: false
  }

  constructor(private fb: FormBuilder, private toastr: ToastrService, private generic_service: GenericService) { }

  ngOnInit(): void {

    let href: any = window.location.href;
    let messages = href.split('/')
    let action: any = this.generic_service.checkActionControls(messages[messages.length - 1])
    this.actionControls = action

    this.cid = sessionStorage.getItem('cid')
    this.form = this.fb.group({
      chargeName: ['', [Validators.required]],
      description: [''],
      uom: [''],
      qty: [''],
      price: ['']
    })

    this.getAllUomMaster()
    this.getAllProductComposition()
    this.getAllBatchInfo();
  }

  ford() {
    let maxLen = 0;
    if (this.singleBatchInfo && this.singleBatchInfo.length > 0 && this.singleBatchInfo[0].chargeDetail && this.singleBatchInfo[0].chargeDetail.length > 0) {
      maxLen = this.singleBatchInfo[0].chargeDetail[0].chargePriceList.length;
    } else if (this.row && this.row.length > 0 && this.row[0].prices) {
      maxLen = this.row[0].prices.length;
    }
    if (this.lastSized < maxLen) {
      this.initialize += 1;
      this.lastSized += 1;
    }
  }

  bacd() {
    if (this.initialize > 0) {
      this.initialize -= 1;
      this.lastSized -= 1;
    }
  }

  onTableDataChange(event: any) {
    this.page = event.page + 1;
  }

  getAllBatchInfo() {
    this.isLoading = true

    this.generic_service.getAllBatchInfo().subscribe(
      (response: any) => {
        this.batchInfoList = response.response || []
        this.count = this.batchInfoList.length
        this.checkBatchRefresh()
        this.isLoading = false
      }
    )
  }

  checkBatchRefresh() {
    if (!this.batchInfoList || this.batchInfoList.length === 0) {
      return;
    }
    if (!this.productCompositioncList || this.productCompositioncList.length === 0) {
      this.generic_service.getAllProductCompositionWithoutPagination().subscribe(
        (response: any) => {
          this.productCompositioncList = response.response || [];
          this.applyBatchRefreshCheck();
        },
        (err: any) => {
          console.error(err);
        }
      );
    } else {
      this.applyBatchRefreshCheck();
    }
  }

  applyBatchRefreshCheck() {
    if (!this.batchInfoList || !this.productCompositioncList || this.productCompositioncList.length === 0) {
      return;
    }
    this.batchInfoList.forEach((batch: any) => {
      let isRefresh = false;
      const matchedComposition = this.productCompositioncList.find(
        (c: any) => c.productName?.trim() === batch.formulaName?.trim()
      );
      if (matchedComposition) {
        if (
          matchedComposition.batchPrice !== undefined &&
          matchedComposition.batchPrice !== null &&
          batch.batchPrice !== undefined &&
          batch.batchPrice !== null &&
          Math.abs(Number(matchedComposition.batchPrice) - Number(batch.batchPrice)) > 0.001
        ) {
          isRefresh = true;
        }
      }
      batch.isRefresh = isRefresh;
    });
  }

  getBatchInfoByWildSearch(searchKey?: any) {
    if (searchKey !== undefined && searchKey !== null) {
      this.searchFilter = searchKey;
    }
    const query = this.searchFilter ? this.searchFilter.toString().trim() : '';
    if (!query) {
      this.getAllBatchInfo();
      return;
    }
    this.isLoading = true;
    this.generic_service.getBatchInfoByWildSearch(query, this.cid).subscribe(
      (response: any) => {
        if (!response?.response || response.response.length === 0) {
          this.batchInfoList = [];
          this.count = 0;
        } else {
          this.batchInfoList = response.response;
          this.count = response.response.length;
          this.checkBatchRefresh();
        }
        this.page = 1;
        this.first = 0;
        this.isLoading = false;
      },
      (error: any) => {
        console.error(error);
        this.batchInfoList = [];
        this.count = 0;
        this.isLoading = false;
      }
    );
  }

  clearSearch() {
    this.searchFilter = '';
    this.page = 1;
    this.first = 0;
    this.getAllBatchInfo();
  }

  refreshAll() {
    this.page = 1;
    this.first = 0;
    this.searchFilter = '';
    this.getAllBatchInfo();
  }

  onRowClick(event: Event, batchInfoId: any) {
    const target = event.target as HTMLElement;
    // Don't trigger row click if an action button was clicked
    if (target.closest('.action-buttons')) {
      return;
    }
    this.getBatchInfo(batchInfoId);
  }

  getBatchInfo(batchInfoId: string) {
    this.generic_service.getBatchInfoById(batchInfoId).subscribe(
      (response: any) => {
        this.singleBatchInfo = []
        let chargeDetailList = response.response.chargeDetailList.filter((c: any) => !(c.profit || c.factoryMargin) && !(c.extraCharges || c.otherCharges) && !(c.salesCharge || c.salesProfit));
        let profitDetailList = response.response.chargeDetailList.filter((c: any) => (c.profit || c.factoryMargin) && !(c.extraCharges || c.otherCharges) && !(c.salesCharge || c.salesProfit));
        let extraChargeList = response.response.chargeDetailList.filter((c: any) => (c.extraCharges || c.otherCharges));
        let salesChargeList = response.response.chargeDetailList.filter((c: any) => (c.salesCharge || c.salesProfit));

        response.response.chargeDetail = chargeDetailList;
        response.response.profitDetail = profitDetailList;
        response.response.extraDetail = extraChargeList;
        response.response.salesChargeDetail = salesChargeList;

        this.singleBatchInfo.push(response.response)

        this.viewData = response.response;
        this.viewData.chargeTotals = [];
        this.viewData.chargeColumns = [];
        if (chargeDetailList.length > 0) {
          this.viewData.chargeColumns = chargeDetailList[0].chargePriceList.slice(1);

          chargeDetailList.forEach((charge: any) => {
            charge.dynamicPrices = charge.chargePriceList.slice(1);
          });

          let priceColumnsCount = chargeDetailList[0].chargePriceList.length - 1;
          for (let i = 0; i < priceColumnsCount; i++) {
            let total = 0;
            chargeDetailList.forEach((charge: any) => {
              total = charge.chargePriceList[i + 1]?.subTotal || 0;
            });
            this.viewData.chargeTotals.push(total);
          }
        }

        if (profitDetailList.length > 0) {
          this.viewData.profitTotals = [];
          // Profits don't have a base charge, so dynamicPrices is just chargePriceList
          profitDetailList.forEach((charge: any) => {
            charge.dynamicPrices = charge.chargePriceList;
          });
          let priceColumnsCount = profitDetailList[0].chargePriceList.length;
          for (let i = 0; i < priceColumnsCount; i++) {
            let total = 0;
            profitDetailList.forEach((charge: any) => {
              total = charge.chargePriceList[i]?.subTotal || 0;
            });
            this.viewData.profitTotals.push(total);
          }
        }

        if (extraChargeList.length > 0) {
          this.viewData.extraTotals = [];
          extraChargeList.forEach((charge: any) => {
            charge.dynamicPrices = charge.chargePriceList.slice(1);
          });
          let priceColumnsCount = extraChargeList[0].chargePriceList.length - 1;
          for (let i = 0; i < priceColumnsCount; i++) {
            let total = 0;
            extraChargeList.forEach((charge: any) => {
              total = charge.chargePriceList[i + 1]?.subTotal || 0;
            });
            this.viewData.extraTotals.push(total);
          }
        }

        this.isViewMode = true;
        this.initialize = 0;
        this.lastSized = 5;
      }
    )
  }

  closeAdd() {
    this.isAdd = false;
    this.isEdit = false;
    this.isViewMode = false;
    this.isRefresh = false;
  }

  closeView() {
    this.isViewMode = false;
  }

  exportExcel() {
    let wb = XLSX.utils.book_new();

    let prevInit = this.initialize;
    let prevLast = this.lastSized;

    // Temporarily show all columns for the export
    this.initialize = 0;
    this.lastSized = 9999;

    setTimeout(() => {
      let tables = document.querySelectorAll('.custom-table');
      if (tables.length > 0) {
        let ws1 = XLSX.utils.table_to_sheet(tables[0] as any);
        XLSX.utils.book_append_sheet(wb, ws1, 'Charges');
      }

      if (tables.length > 1) {
        let ws2 = XLSX.utils.table_to_sheet(tables[1] as any);
        XLSX.utils.book_append_sheet(wb, ws2, 'Profits');
      }

      XLSX.writeFile(wb, 'batch-info-' + (this.viewData?.batchName || 'details') + '.xlsx');

      // Revert pagination
      this.initialize = prevInit;
      this.lastSized = prevLast;
    }, 100);
  }

  download() {
    let initialData = document.getElementById('view-batch-container');
    if (initialData) {
      let prevInit = this.initialize;
      let prevLast = this.lastSized;

      // Temporarily show all columns for the PDF export
      this.initialize = 0;
      this.lastSized = 9999;

      setTimeout(() => {
        let data = document.getElementById('view-batch-container');
        if (!data) return;

        // temporarily hide pagination arrows and action buttons
        const actionBtns = data.querySelectorAll('.footer-actions, .btn-back-view, .pagination-arrows');
        actionBtns.forEach((el: any) => el.style.display = 'none');

        // temporarily remove overflow to capture full width
        const wrappers = data.querySelectorAll('.custom-table-wrapper');
        wrappers.forEach((el: any) => el.style.overflow = 'visible');

        html2canvas(data, {
          scale: 2,
          useCORS: true,
          backgroundColor: '#ffffff'
        }).then(canvas => {
          let imgWidth = 297; // Landscape A4 width
          let pageHeight = 210; // Landscape A4 height
          let ratio = imgWidth / canvas.width;
          let imgHeight = canvas.height * ratio;

          let pdf = new jsPDF('l', 'mm', 'a4');
          let yOffset = 0;

          while (yOffset < imgHeight) {
            let currentHeight = Math.min(pageHeight, imgHeight - yOffset);

            let pageCanvas = document.createElement('canvas');
            pageCanvas.width = canvas.width;
            let chunkHeightPx = currentHeight / ratio;
            pageCanvas.height = chunkHeightPx;

            let ctx = pageCanvas.getContext('2d');
            if (ctx) {
              // Fill white background just in case
              ctx.fillStyle = '#ffffff';
              ctx.fillRect(0, 0, pageCanvas.width, pageCanvas.height);
              // Draw the sliced portion
              ctx.drawImage(
                canvas,
                0, yOffset / ratio, canvas.width, chunkHeightPx,
                0, 0, canvas.width, chunkHeightPx
              );
            }

            let pageData = pageCanvas.toDataURL('image/jpeg', 1.0);

            if (yOffset > 0) {
              pdf.addPage();
            }

            pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, currentHeight);
            yOffset += pageHeight;
          }

          pdf.save('batch-info-' + (this.viewData?.batchName || 'details') + '.pdf');

          // restore buttons and overflow
          actionBtns.forEach((el: any) => el.style.display = '');
          wrappers.forEach((el: any) => el.style.overflow = '');

          // Revert pagination
          this.initialize = prevInit;
          this.lastSized = prevLast;
        });
      }, 100);
    }
  }

  openAdd() {
    this.isAdd = true;
    this.isEdit = false;
    this.isRefresh = false;
    this.oldBatchPrice = "";
    this.formulaName = "";
    this.batchName = "";
    this.batchQty = "";
    this.batchPrice = "";
    this.batchUOM = "";
    this.row = [
      {
        chargeName: '',
        isPercentage: false,
        baseCharge: '',
        baseLabel: 'Base',
        prices: [
          {
            "qty": "",
            "uom": "",
            "cPrice": "",
            "priceLabel": "Price",
            "value": "",
            "totalValue": "",
            "individualCharge": false
          }
        ]
      }
    ];
    this.profitValue = [];
    this.totalValue = [];
    this.totalProfitValue = [];
    this.extraRow = [];
    this.totalExtraValue = [];
    this.salesChargeValue = [];
    this.totalSalesChargeValue = [];
    this.initialize = 0;
    this.lastSized = 5;
  }

  cancelModel() {
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }


  deleteBatch(id: any) {
    this.deleteBatchInfoId = id
  }

  deleteBatchInfo() {
    this.generic_service.deleteBatchInfo(this.deleteBatchInfoId).subscribe(
      (res: any) => {
        this.getAllBatchInfo()
        this.toastr.success("Successfully Deleted")
        this.cancelModel()
      },
      (err: any) => {
        this.toastr.error(err.errors[0].description)
      }
    )
  }






  forwardArrow() {
    let maxLen = 0;
    if (this.isViewMode && this.viewData && this.viewData.chargeColumns) {
      maxLen = this.viewData.chargeColumns.length;
    } else if (this.row && this.row.length > 0 && this.row[0].prices) {
      maxLen = this.row[0].prices.length;
    }

    if (this.lastSized < maxLen) {
      this.initialize += 1;
      this.lastSized += 1;
    }
  }

  backArrow() {
    if (this.initialize > 0) {
      this.initialize -= 1;
      this.lastSized -= 1;
    }
  }

  getAllProductComposition() {
    this.generic_service.getAllProductCompositionWithoutPagination().subscribe(
      (response: any) => {
        this.productCompositioncList = response.response || []
        this.applyBatchRefreshCheck()
      }
    )
  }

  batchNameSelected() {
    this.singleproductCompositionData = []
    for (let i = 0; i < this.productCompositioncList.length; i++) {
      if (this.productCompositioncList[i].productName == this.formulaName) {
        this.singleproductCompositionData.push(this.productCompositioncList[i])
      }
    }

    console.log(this.singleproductCompositionData)
    this.batchQty = this.singleproductCompositionData[0].batchQuantity
    this.batchPrice = this.singleproductCompositionData[0].batchPrice
    this.supportedUOMObjList = this.singleproductCompositionData[0].supportedUOMObjList
    for (var i = 0; i < this.singleproductCompositionData[0].supportedUOMObjList.length; i++) {
      if (this.singleproductCompositionData[0].supportedUOMObjList[i].isDefault == true) {
        this.batchUOM = this.singleproductCompositionData[0].supportedUOMObjList[i].uomName
      }
    }
    this.baseCalculate()
  }

  qtyChanged(r: any, i: any, event: any) {
    let val = event.target.value;
    for (let j = 0; j < this.row.length; j++) {
      this.row[j].prices[i].qty = val;
      if (this.row[r].prices[i].uom == this.batchUOM) {
        this.row[j].prices[i].cPrice = val;
      }
    }
    this.syncExtraRowWithBasePrices();
  }

  syncExtraRowWithBasePrices() {
    if (!this.row || this.row.length === 0 || !this.extraRow || this.extraRow.length === 0) return;
    let basePrices = this.row[0].prices;
    this.extraRow.forEach((r: any) => {
      while (r.prices.length < basePrices.length) {
        let colIdx = r.prices.length;
        r.prices.push({
          qty: basePrices[colIdx].qty,
          uom: basePrices[colIdx].uom,
          cPrice: basePrices[colIdx].cPrice,
          priceLabel: basePrices[colIdx].priceLabel,
          value: "",
          totalValue: "",
          individualCharge: false
        });
      }
      r.prices.forEach((price: any, j: number) => {
        if (basePrices[j]) {
          price.qty = basePrices[j].qty;
          price.uom = basePrices[j].uom;
          price.priceLabel = basePrices[j].priceLabel;
          if (basePrices[j].cPrice) {
            price.cPrice = basePrices[j].cPrice;
          }
        }
      });
    });
  }

  addp() {
    this.row[0].prices.push(
      {
        "qty": "",
        "uom": this.batchUOM,
        "cPrice": "",
        "priceLabel": this.batchUOM,
        "value": "",
        "totalValue": "",
        "individualCharge": false
      }
    )

    if (this.extraRow && this.extraRow.length > 0) {
      this.extraRow[0].prices.push({
        "qty": "",
        "uom": this.batchUOM,
        "cPrice": "",
        "priceLabel": this.batchUOM,
        "value": "",
        "totalValue": "",
        "individualCharge": false
      });
    }

    let rowSize = this.row.length;
    let columnSize = this.row[0].prices.length
    for (let i = 1; i < rowSize; i++) {
      let diff = columnSize - this.row[i].prices.length;
      for (let j = 0; j < diff; j++) {
        this.row[i].prices.push(
          {
            "qty": "",
            "uom": this.batchUOM,
            "cPrice": "",
            "priceLabel": this.batchUOM,
            "value": "",
            "totalValue": "",
            "individualCharge": false
          }
        )
      }
    }

    if (this.extraRow && this.extraRow.length > 0) {
      let extraRowSize = this.extraRow.length;
      for (let i = 1; i < extraRowSize; i++) {
        let diff = columnSize - this.extraRow[i].prices.length;
        for (let j = 0; j < diff; j++) {
          this.extraRow[i].prices.push({
            "qty": "",
            "uom": this.batchUOM,
            "cPrice": "",
            "priceLabel": this.batchUOM,
            "value": "",
            "totalValue": "",
            "individualCharge": false
          });
        }
      }
    }

    this.syncExtraRowWithBasePrices();

    if (this.row[0].prices.length > 5) {
      this.lastSized = this.row[0].prices.length;
      this.initialize = this.row[0].prices.length - 5;
    }
  }

  baseCalculate() {
    if (this.batchPrice != "" && this.batchQty != "" && this.batchUOM != "") {
      let price: any = Number(this.batchPrice) / Number(this.batchQty)
      this.row[0].baseLabel = "Base"
      this.row[0].chargeName = 'Base Charge'

      if (String(price).includes('.')) {
        this.row[0].baseCharge = price.toFixed(2)
      } else {
        this.row[0].baseCharge = price
      }
      this.row[0].prices[0].uom = this.batchUOM
      this.row[0].prices[0].cPrice = 1
      this.row[0].prices[0].priceLabel = this.batchUOM
    }

  }

  addrow() {
    let price = []
    for (let i = 0; i < this.row[0].prices.length; i++) {
      price.push(
        {
          "qty": this.row[0].prices[i].qty,
          "uom": this.row[0].prices[i].uom,
          "cPrice": this.row[0].prices[i].cPrice,
          "priceLabel": this.row[0].prices[i].priceLabel,
          "value": "",
          "totalValue": "",
          "individualCharge": false
        }
      )
    }

    this.row.push(
      {
        chargeName: '',
        isPercentage: false,
        baseCharge: '',
        prices: price
      }
    )
  }

  save() {
    let chargeDetailList: any = [];

    this.row.forEach((r: any) => {
      let obj: any = {
        "slNo": 0,
        "chargeId": 0,
        "chargeName": r.chargeName,
        "percentage": r.isPercentage,
        "profitPercentage": 0,
        "profit": false,
        "salesCharge": false,
        "extraCharges": false,
        "sectionName": "",
        "factoryMargin": false,
        "otherCharges": false,
        "salesProfit": false,
        "fmType": false,
        "ocType": false,
        "spType": false,
        "chargePriceList": []
      };

      obj.chargePriceList.push({
        "slNo": 0,
        "uom": String(this.batchUOM),
        "qty": 1,
        "unitPrice": Number(r.baseCharge),
        "subTotal": 0,
        "individualCharge": false
      });

      r.prices.forEach((price: any) => {
        obj.chargePriceList.push({
          "slNo": 0,
          "uom": String(price.uom),
          "qty": Number(price.qty),
          "unitPrice": Number(price.value),
          "subTotal": Number(price.totalValue),
          "individualCharge": price.individualCharge
        });
      });
      chargeDetailList.push(obj);
    });

    this.profitValue.forEach((p: any) => {
      let obj: any = {
        "slNo": 0,
        "chargeId": 0,
        "chargeName": p.profitName,
        "percentage": false,
        "profitPercentage": Number(p.percentage),
        "profit": true,
        "salesCharge": false,
        "extraCharges": false,
        "sectionName": "Factory Profits",
        "factoryMargin": true,
        "otherCharges": false,
        "salesProfit": false,
        "fmType": false,
        "ocType": false,
        "spType": false,
        "chargePriceList": []
      };

      p.profits.forEach((profit: any) => {
        obj.chargePriceList.push({
          "slNo": 0,
          "uom": String(profit.uom),
          "qty": Number(profit.qty),
          "unitPrice": Number(profit.value),
          "subTotal": Number(profit.totalValue),
          "individualCharge": profit.individualCharge
        });
      });
      chargeDetailList.push(obj);
    });

    this.extraRow.forEach((r: any) => {
      let obj: any = {
        "slNo": 0,
        "chargeId": 0,
        "chargeName": r.chargeName,
        "percentage": r.isPercentage,
        "profitPercentage": 0,
        "profit": false,
        "salesCharge": false,
        "extraCharges": true,
        "sectionName": "Extra Charges",
        "factoryMargin": false,
        "otherCharges": true,
        "salesProfit": false,
        "fmType": false,
        "ocType": false,
        "spType": false,
        "chargePriceList": []
      };

      obj.chargePriceList.push({
        "slNo": 0,
        "uom": String(this.batchUOM),
        "qty": 1,
        "unitPrice": Number(r.baseCharge),
        "subTotal": 0,
        "individualCharge": false
      });

      r.prices.forEach((price: any) => {
        obj.chargePriceList.push({
          "slNo": 0,
          "uom": String(price.uom),
          "qty": Number(price.qty),
          "unitPrice": Number(price.value),
          "subTotal": Number(price.totalValue),
          "individualCharge": price.individualCharge
        });
      });
      chargeDetailList.push(obj);
    });

    this.salesChargeValue.forEach((s: any) => {
      let obj: any = {
        "slNo": 0,
        "chargeId": 0,
        "chargeName": s.chargeName,
        "percentage": false,
        "profitPercentage": Number(s.percentage),
        "profit": false,
        "salesCharge": true,
        "extraCharges": false,
        "sectionName": "Factory Profits",
        "factoryMargin": false,
        "otherCharges": false,
        "salesProfit": true,
        "fmType": false,
        "ocType": false,
        "spType": s.spType || false,
        "chargePriceList": []
      };

      s.charges.forEach((charge: any) => {
        obj.chargePriceList.push({
          "slNo": 0,
          "uom": String(charge.uom),
          "qty": Number(charge.qty),
          "unitPrice": Number(charge.value),
          "subTotal": Number(charge.totalValue),
          "individualCharge": charge.individualCharge
        });
      });
      chargeDetailList.push(obj);
    });

    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "batchInfoId": this.isEdit ? this.singleBatchInfo[0].batchInfoId : 0,
      "batchDate": 0,
      "formulaName": String(this.formulaName),
      "batchName": String(this.batchName),
      "batchQTY": Number(this.batchQty),
      "batchUOM": String(this.batchUOM),
      "batchPrice": Number(this.batchPrice),
      "chargeDetailList": chargeDetailList,
      "cid": Number(this.cid)
    }

    console.log(body)

    const request = this.isEdit
      ? this.generic_service.editBatchInfo(body)
      : this.generic_service.addBatchInfo(body);

    request.subscribe(
      (response: any) => {
        this.toastr.success(response.message)
        this.getAllBatchInfo();
        this.closeAdd();
      },
      (error: any) => {
        if (error?.error?.errors?.[0]?.description) {
          this.toastr.error(error.error.errors[0].description);
        } else {
          this.toastr.error("Operation failed");
        }
      }
    )
  }


  getAllUomMaster() {
    this.generic_service.getAllUomMaster().subscribe(
      (res: any) => {
        this.uomData = res.response
      }
    )
  }

  select(i: any) {
    this.selectedIndex = i
    this.priceInput = ""
    this.uomInput = ""

  }

  generate() {
    if (!this.row || this.row.length === 0) return;

    let rowSize = this.row.length;
    let basePrices = this.row[0].prices;

    for (let i = 1; i < rowSize; i++) {
      for (let j = 0; j < this.row[i].prices.length; j++) {
        this.row[i].prices[j].qty = basePrices[j].qty;
        this.row[i].prices[j].uom = basePrices[j].uom;
        this.row[i].prices[j].priceLabel = basePrices[j].priceLabel;
      }
    }

    let existingTotalValue = this.totalValue || [];
    this.totalValue = basePrices.map((_: any, i: number) => ({
      column: i,
      label: "",
      uom: "",
      qty: "",
      total: 0,
      oldTotal: existingTotalValue[i] ? existingTotalValue[i].oldTotal : 0
    }));

    this.row.forEach((r: any) => {
      r.prices.forEach((price: any, j: number) => {
        if (!price.individualCharge) {
          if (r.isPercentage) {
            let percentage = this.totalValue[j].total / Number(r.baseCharge);
            price.value = String(percentage).includes('.') ? percentage.toFixed(2) : percentage;
          } else {
            let val = Number(r.baseCharge) * Number(price.cPrice);
            price.value = String(val).includes('.') ? val.toFixed(2) : val;
          }
        }

        this.totalValue[j].total += Number(price.value);
        this.totalValue[j].qty = price.qty;
        this.totalValue[j].uom = price.uom;
        this.totalValue[j].label = `${price.qty} ${price.uom}`;

        price.totalValue = this.totalValue[j].total;
      });
    });

    this.syncExtraRowWithBasePrices();

    if (this.profitValue.length === 0) {
      this.addProfit();
    }

    if (this.salesChargeValue.length === 0) {
      this.addSalesCharge();
    }
  }


  generate1() {
    if (!this.row || this.row.length === 0) return;

    let rowSize = this.row.length;
    let basePrices = this.row[0].prices;

    for (let i = 1; i < rowSize; i++) {
      for (let j = 0; j < this.row[i].prices.length; j++) {
        this.row[i].prices[j].qty = basePrices[j].qty;
        this.row[i].prices[j].uom = basePrices[j].uom;
        this.row[i].prices[j].priceLabel = basePrices[j].priceLabel;
      }
    }

    let existingTotalValue = this.totalValue || [];
    this.totalValue = basePrices.map((_: any, i: number) => ({
      column: i,
      label: "",
      uom: "",
      qty: "",
      total: 0,
      oldTotal: existingTotalValue[i] ? existingTotalValue[i].oldTotal : 0
    }));

    this.row.forEach((r: any) => {
      r.prices.forEach((price: any, j: number) => {
        // if (r.isPercentage) {
        //   let percentage = this.totalValue[j].total / Number(r.baseCharge);
        //   price.value = String(percentage).includes('.') ? percentage.toFixed(2) : percentage;
        // } else {
        //   let val = Number(r.baseCharge) * Number(price.cPrice);
        //   price.value = String(val).includes('.') ? val.toFixed(2) : val;
        // }

        this.totalValue[j].total += Number(price.value);
        this.totalValue[j].qty = price.qty;
        this.totalValue[j].uom = price.uom;
        this.totalValue[j].label = `${price.qty} ${price.uom}`;

        price.totalValue = this.totalValue[j].total;
      });
    });
    this.syncExtraRowWithBasePrices();
  }

  addc() {
    let label = this.priceInput + " " + this.uomInput
    this.row[0].prices[this.selectedIndex].qty = this.priceInput
    this.row[0].prices[this.selectedIndex].uom = this.uomInput
    this.row[0].prices[this.selectedIndex].priceLabel = label
    if (this.uomInput != this.batchUOM) {
      this.generic_service.calculateConPrice(this.batchUOM, this.uomInput, this.priceInput).subscribe(
        (response: any) => {
          this.row[0].prices[this.selectedIndex].cPrice = response.response
          this.syncExtraRowWithBasePrices();
        },
        (error: any) => {
          console.log(error)
        }
      )
    } else {
      this.row[0].prices[this.selectedIndex].cPrice = this.uomInput
    }

    this.syncExtraRowWithBasePrices();
    document.getElementById("closeModalButton4")?.click()
  }

  removeRow(i: any) {
    this.row.splice(i, 1)
    this.generate()
  }

  removeCol(i: any) {
    let rowSize = this.row.length;
    for (let j = 0; j < rowSize; j++) {
      this.row[j].prices.splice(i, 1)
    }

    if (this.extraRow && this.extraRow.length > 0) {
      let extraRowSize = this.extraRow.length;
      for (let j = 0; j < extraRowSize; j++) {
        this.extraRow[j].prices.splice(i, 1);
      }
    }

    if (this.initialize > 0) {
      this.initialize -= 1;
      this.lastSized -= 1;
    }

    this.generate()

  }

  addProfit() {
    let obj: any = {
      profitName: "Factory Margin",
      percentage: "",
      profits: [],
    }
    for (let j = 0; j < this.totalValue.length; j++) {
      obj.profits.push(
        {
          column: j,
          value: "",
          totalValue: "",
          uom: this.totalValue[j].uom,
          qty: this.totalValue[j].qty,
          total: this.totalValue[j].total
        }
      )
    }
    this.profitValue.push(obj)
  }

  removeProfit(i: any) {
    this.profitValue.splice(i, 1);
    this.calculateProfitValue();
  }

  addSalesCharge() {
    let obj: any = {
      chargeName: "",
      percentage: "",
      spType: true,
      charges: [],
    }
    for (let j = 0; j < this.totalValue.length; j++) {
      obj.charges.push(
        {
          column: j,
          value: "",
          totalValue: "",
          uom: this.totalValue[j].uom,
          qty: this.totalValue[j].qty,
          total: this.totalExtraValue && this.totalExtraValue[j] ? this.totalExtraValue[j].total : this.totalValue[j].total
        }
      )
    }
    this.salesChargeValue.push(obj)
  }

  removeSalesCharge(i: any) {
    this.salesChargeValue.splice(i, 1);
    this.calculateSalesChargeValue();
  }

  calculateSalesChargeValue() {
    this.calculateExtraValue();

    this.salesChargeValue.forEach((charge: any) => {
      let existingCharges = charge.charges || [];
      charge.charges = this.totalExtraValue.map((tv: any, j: number) => ({
        column: j,
        value: "",
        totalValue: "",
        oldTotalValue: existingCharges[j] ? existingCharges[j].oldTotalValue : undefined,
        uom: this.totalValue[j].uom,
        qty: this.totalValue[j].qty,
        total: tv.total
      }));
    });

    let existingTotalSalesChargeValue = this.totalSalesChargeValue || [];
    this.totalSalesChargeValue = this.totalExtraValue.map((tv: any, i: number) => ({
      column: i,
      total: tv.total,
      oldTotal: existingTotalSalesChargeValue[i] ? existingTotalSalesChargeValue[i].oldTotal : (tv.oldTotal || 0)
    }));

    this.salesChargeValue.forEach((charge: any) => {
      charge.charges.forEach((c: any, j: number) => {
        let val = (Number(charge.percentage) / 100) * c.total;
        c.value = charge.spType ? val : -val;
        c.totalValue = c.total + c.value;

        if (this.totalSalesChargeValue && this.totalSalesChargeValue[j]) {
          this.totalSalesChargeValue[j].total += c.value;
        }
      });
    });
  }

  calculateProfitValue() {
    this.profitValue.forEach((profit: any) => {
      let existingProfits = profit.profits || [];
      profit.profits = this.totalValue.map((tv: any, j: number) => ({
        column: j,
        value: "",
        totalValue: "",
        oldTotalValue: existingProfits[j] ? existingProfits[j].oldTotalValue : undefined,
        uom: tv.uom,
        qty: tv.qty,
        total: tv.total
      }));
    });

    let existingTotalProfitValue = this.totalProfitValue || [];
    this.totalProfitValue = this.totalValue.map((tv: any, i: number) => ({
      column: i,
      total: tv.total,
      oldTotal: existingTotalProfitValue[i] ? existingTotalProfitValue[i].oldTotal : (tv.oldTotal || 0)
    }));

    this.profitValue.forEach((profit: any) => {
      profit.profits.forEach((p: any, j: number) => {
        p.value = (Number(profit.percentage) / 100) * p.total;
        p.totalValue = p.value + p.total;

        if (this.totalProfitValue && this.totalProfitValue[j]) {
          this.totalProfitValue[j].total += p.value;
        }
      });
    });

    this.calculateExtraValue();
  }

  refreshBatch(batchInfoId: string) {
    this.generic_service.getBatchInfoById(batchInfoId).subscribe(
      (response: any) => {
        this.singleBatchInfo = []
        this.row = []
        this.profitValue = []
        this.totalValue = []
        this.totalProfitValue = []
        this.salesChargeValue = []
        this.totalSalesChargeValue = []

        this.extraRow = []
        this.totalExtraValue = []

        this.formulaName = response.response.formulaName
        this.batchName = response.response.batchName
        this.batchUOM = response.response.batchUOM
        this.batchQty = response.response.batchQTY
        this.batchPrice = response.response.batchPrice
        this.oldBatchPrice = response.response.batchPrice

        let chargeDetailList = response.response.chargeDetailList.filter((c: any) => !(c.profit || c.factoryMargin) && !(c.extraCharges || c.otherCharges) && !(c.salesCharge || c.salesProfit));
        let profitDetailList = response.response.chargeDetailList.filter((c: any) => (c.profit || c.factoryMargin) && !(c.extraCharges || c.otherCharges) && !(c.salesCharge || c.salesProfit));
        let extraChargeList = response.response.chargeDetailList.filter((c: any) => (c.extraCharges || c.otherCharges));
        let salesChargeList = response.response.chargeDetailList.filter((c: any) => (c.salesCharge || c.salesProfit));

        response.response.chargeDetail = chargeDetailList
        response.response.profitDetail = profitDetailList
        response.response.extraDetail = extraChargeList
        response.response.salesChargeDetail = salesChargeList

        this.row = chargeDetailList.map((charge: any) => {
          let baseVal = charge.chargePriceList[0].unitPrice;
          return {
            chargeName: charge.chargeName,
            isPercentage: charge.percentage,
            baseCharge: baseVal,
            oldBaseCharge: baseVal,
            baseLabel: 'Base',
            prices: charge.chargePriceList.slice(1).map((price: any) => ({
              qty: price.qty,
              uom: price.uom,
              cPrice: price.qty,
              priceLabel: "Price",
              value: price.unitPrice,
              totalValue: price.subTotal,
              oldTotalValue: price.subTotal,
              individualCharge: price.individualCharge
            }))
          }
        });

        let basePrices = this.row.length > 0 ? this.row[0].prices : [];
        this.totalValue = basePrices.map((_: any, i: number) => {
          let oldTotal = 0;
          if (chargeDetailList.length > 0) {
            oldTotal = chargeDetailList[chargeDetailList.length - 1].chargePriceList[i + 1]?.subTotal || 0;
          }
          return {
            column: i,
            label: "",
            uom: "",
            qty: "",
            total: 0,
            oldTotal: oldTotal
          };
        });

        this.profitValue = profitDetailList.map((profit: any) => ({
          profitName: profit.chargeName,
          percentage: profit.profitPercentage,
          profits: profit.chargePriceList.map((price: any, j: number) => ({
            column: j,
            value: price.unitPrice,
            totalValue: price.subTotal,
            oldTotalValue: price.subTotal,
            uom: this.totalValue[j]?.uom || price.uom,
            qty: this.totalValue[j]?.qty || price.qty,
            total: this.totalValue[j]?.total || 0
          }))
        }));

        this.totalProfitValue = this.totalValue.map((tv: any, i: number) => {
          let oldTotal = tv.oldTotal;
          if (profitDetailList.length > 0) {
            oldTotal = profitDetailList[profitDetailList.length - 1].chargePriceList[i + 1]?.subTotal || 0;
          }
          return {
            column: i,
            total: 0,
            oldTotal: oldTotal
          };
        });

        this.salesChargeValue = salesChargeList.map((charge: any) => ({
          chargeName: charge.chargeName,
          percentage: charge.profitPercentage,
          spType: charge.spType || false,
          charges: charge.chargePriceList.map((price: any, j: number) => ({
            column: j,
            value: price.unitPrice,
            totalValue: price.subTotal,
            oldTotalValue: price.subTotal,
            uom: this.totalValue[j]?.uom || price.uom,
            qty: this.totalValue[j]?.qty || price.qty,
            total: this.totalValue[j]?.total || 0
          }))
        }));

        this.totalSalesChargeValue = this.totalProfitValue.map((tv: any, i: number) => {
          let oldTotal = tv.oldTotal;
          if (salesChargeList.length > 0) {
            oldTotal = salesChargeList[salesChargeList.length - 1].chargePriceList[i + 1]?.subTotal || 0;
          }
          return {
            column: i,
            total: 0,
            oldTotal: oldTotal
          };
        });

        this.extraRow = extraChargeList.map((charge: any) => {
          let baseVal = charge.chargePriceList[0].unitPrice;
          return {
            chargeName: charge.chargeName,
            isPercentage: charge.percentage,
            baseCharge: baseVal,
            oldBaseCharge: baseVal,
            baseLabel: 'Base',
            prices: charge.chargePriceList.slice(1).map((price: any) => ({
              qty: price.qty,
              uom: price.uom,
              cPrice: price.qty,
              priceLabel: "Price",
              value: price.unitPrice,
              totalValue: price.subTotal,
              oldTotalValue: price.subTotal,
              individualCharge: price.individualCharge
            }))
          }
        });

        this.totalExtraValue = this.totalProfitValue.map((tpv: any, i: number) => {
          let oldTotal = tpv.oldTotal;
          if (extraChargeList.length > 0) {
            oldTotal = extraChargeList[extraChargeList.length - 1].chargePriceList[i + 1]?.subTotal || 0;
          }
          return {
            column: i,
            total: 0,
            oldTotal: oldTotal
          };
        });

        this.singleBatchInfo.push(response.response)

        let matchedComposition = this.productCompositioncList.find((c: any) => c.productName === this.formulaName);
        if (matchedComposition) {
          this.batchPrice = matchedComposition.batchPrice;
          this.supportedUOMObjList = matchedComposition.supportedUOMObjList;
          this.baseCalculate();
        }

        this.generate();
        this.calculateProfitValue();
        this.calculateSalesChargeValue();

        this.isAdd = false;
        this.isEdit = true;
        this.isRefresh = true;
        this.initialize = 0;
        this.lastSized = 5;
      }
    )
  }

  BatchInfoEdit(batchInfoId: string) {
    this.generic_service.getBatchInfoById(batchInfoId).subscribe(
      (response: any) => {
        this.singleBatchInfo = []
        this.row = []
        this.profitValue = []
        this.totalValue = []
        this.totalProfitValue = []
        this.salesChargeValue = []
        this.totalSalesChargeValue = []

        this.extraRow = []
        this.totalExtraValue = []

        this.formulaName = response.response.formulaName
        let matchedComposition = this.productCompositioncList.find((c: any) => c.productName === this.formulaName);
        if (matchedComposition) {
          this.supportedUOMObjList = matchedComposition.supportedUOMObjList;
        }

        this.batchName = response.response.batchName
        this.batchUOM = response.response.batchUOM
        this.batchQty = response.response.batchQTY
        this.batchPrice = response.response.batchPrice


        let chargeDetailList = response.response.chargeDetailList.filter((c: any) => !(c.profit || c.factoryMargin) && !(c.extraCharges || c.otherCharges) && !(c.salesCharge || c.salesProfit));
        let profitDetailList = response.response.chargeDetailList.filter((c: any) => (c.profit || c.factoryMargin) && !(c.extraCharges || c.otherCharges) && !(c.salesCharge || c.salesProfit));
        let extraChargeList = response.response.chargeDetailList.filter((c: any) => (c.extraCharges || c.otherCharges));
        let salesChargeList = response.response.chargeDetailList.filter((c: any) => (c.salesCharge || c.salesProfit));

        response.response.chargeDetail = chargeDetailList
        response.response.profitDetail = profitDetailList
        response.response.extraDetail = extraChargeList
        response.response.salesChargeDetail = salesChargeList

        this.row = chargeDetailList.map((charge: any) => ({
          chargeName: charge.chargeName,
          isPercentage: charge.percentage,
          baseCharge: charge.chargePriceList[0].unitPrice,
          baseLabel: 'Base',
          prices: charge.chargePriceList.slice(1).map((price: any) => ({
            qty: price.qty,
            uom: price.uom,
            cPrice: price.qty,
            priceLabel: "Price",
            value: price.unitPrice,
            totalValue: price.subTotal,
            individualCharge: price.individualCharge
          }))
        }));

        this.generate()


        this.profitValue = profitDetailList.map((profit: any) => ({
          profitName: profit.chargeName,
          percentage: profit.profitPercentage,
          profits: profit.chargePriceList.map((price: any, j: number) => ({
            column: j,
            value: price.unitPrice,
            totalValue: price.subTotal,
            oldTotalValue: price.subTotal,
            uom: this.totalValue[j]?.uom || price.uom,
            qty: this.totalValue[j]?.qty || price.qty,
            total: this.totalValue[j]?.total || 0
          }))
        }));

        this.totalProfitValue = this.totalValue.map((tv: any, i: number) => {
          let oldTotal = tv.oldTotal;
          if (profitDetailList.length > 0) {
            oldTotal = profitDetailList[profitDetailList.length - 1].chargePriceList[i + 1]?.subTotal || 0;
          }
          return {
            column: i,
            total: 0,
            oldTotal: oldTotal
          };
        });

        this.salesChargeValue = salesChargeList.map((charge: any) => ({
          chargeName: charge.chargeName,
          percentage: charge.profitPercentage,
          spType: charge.spType || false,
          charges: charge.chargePriceList.map((price: any, j: number) => ({
            column: j,
            value: price.unitPrice,
            totalValue: price.subTotal,
            oldTotalValue: price.subTotal,
            uom: this.totalValue[j]?.uom || price.uom,
            qty: this.totalValue[j]?.qty || price.qty,
            total: this.totalValue[j]?.total || 0
          }))
        }));

        this.totalSalesChargeValue = this.totalProfitValue.map((tv: any, i: number) => {
          let oldTotal = tv.oldTotal;
          if (salesChargeList.length > 0) {
            oldTotal = salesChargeList[salesChargeList.length - 1].chargePriceList[i + 1]?.subTotal || 0;
          }
          return {
            column: i,
            total: 0,
            oldTotal: oldTotal
          };
        });

        this.extraRow = extraChargeList.map((charge: any) => {
          let baseVal = charge.chargePriceList[0].unitPrice;
          return {
            chargeName: charge.chargeName,
            isPercentage: charge.percentage,
            baseCharge: baseVal,
            oldBaseCharge: baseVal,
            baseLabel: 'Base',
            prices: charge.chargePriceList.slice(1).map((price: any) => ({
              qty: price.qty,
              uom: price.uom,
              cPrice: price.qty,
              priceLabel: "Price",
              value: price.unitPrice,
              totalValue: price.subTotal,
              oldTotalValue: price.subTotal,
              individualCharge: price.individualCharge
            }))
          }
        });

        this.totalExtraValue = this.totalProfitValue.map((tpv: any, i: number) => {
          let oldTotal = tpv.oldTotal;
          if (extraChargeList.length > 0) {
            oldTotal = extraChargeList[extraChargeList.length - 1].chargePriceList[i + 1]?.subTotal || 0;
          }
          return {
            column: i,
            total: 0,
            oldTotal: oldTotal
          };
        });

        this.calculateProfitValue()
        this.calculateSalesChargeValue()

        this.singleBatchInfo.push(response.response)
        this.isAdd = true
        this.isEdit = true
        this.initialize = 0;
        this.lastSized = 5;
      }
    )
  }


  priceChanged(r: any, i: any, event: any) {
    let basePrice = Number(String(this.row[r].baseCharge).replace(/,/g, ''));
    let qty = Number(String(this.row[r].prices[i].qty).replace(/,/g, ''));
    let enteredPrice = Number(String(this.row[r].prices[i].value).replace(/,/g, ''));

    if (!isNaN(basePrice) && !isNaN(qty) && !isNaN(enteredPrice)) {
      let expectedVal = basePrice * qty;
      let expectedStr = String(expectedVal).includes('.') ? expectedVal.toFixed(2) : String(expectedVal);
      this.row[r].prices[i].individualCharge = (Number(expectedStr) !== enteredPrice);
    } else {
      this.row[r].prices[i].individualCharge = true;
    }

    console.log(this.row[r].prices[i])
    this.row[r].prices[i].totalValue = Number(this.row[r].prices[i].value) + Number(this.row[r - 1].prices[i].totalValue);
    this.generate1()
  }

  addExtraRow() {
    let price = [];
    let refRow = this.row && this.row.length > 0 ? this.row[0].prices : [];
    for (let i = 0; i < refRow.length; i++) {
      price.push(
        {
          "qty": refRow[i].qty,
          "uom": refRow[i].uom,
          "cPrice": refRow[i].cPrice,
          "priceLabel": refRow[i].priceLabel,
          "value": "",
          "totalValue": "",
          "individualCharge": false
        }
      )
    }

    this.extraRow.push(
      {
        chargeName: '',
        isPercentage: false,
        baseCharge: '',
        prices: price
      }
    )
  }

  removeExtraRow(r: any) {
    this.extraRow.splice(r, 1);
    this.calculateExtraValue();
  }

  calculateExtraValue(isManualEdit: boolean = false) {
    this.syncExtraRowWithBasePrices();

    let existingTotalExtraValue = this.totalExtraValue || [];
    this.totalExtraValue = this.totalProfitValue.map((tpv: any, i: number) => ({
      column: i,
      total: tpv.total,
      oldTotal: existingTotalExtraValue[i] ? existingTotalExtraValue[i].oldTotal : (tpv.oldTotal || 0)
    }));

    this.extraRow.forEach((r: any) => {
      r.prices.forEach((price: any, j: number) => {
        if (this.row && this.row.length > 0 && this.row[0].prices[j]) {
          price.cPrice = this.row[0].prices[j].cPrice;
          price.qty = this.row[0].prices[j].qty;
          price.uom = this.row[0].prices[j].uom;
          price.priceLabel = this.row[0].prices[j].priceLabel;
        }

        if (r.baseCharge && price.cPrice && !isManualEdit && !price.individualCharge) {
          let parsedBaseCharge = Number(String(r.baseCharge).replace(/,/g, ''));
          let parsedCPrice = Number(String(price.cPrice).replace(/,/g, ''));

          if (!isNaN(parsedBaseCharge) && !isNaN(parsedCPrice)) {
            let val = parsedBaseCharge * parsedCPrice;
            price.value = String(val).includes('.') ? val.toFixed(2) : val;
          }
        }

        if (this.totalExtraValue && this.totalExtraValue[j] && price.value) {
          let parsedVal = Number(String(price.value).replace(/,/g, ''));
          if (!isNaN(parsedVal)) {
            this.totalExtraValue[j].total += parsedVal;
          }
          price.totalValue = this.totalExtraValue[j].total;
        } else if (this.totalExtraValue && this.totalExtraValue[j]) {
          price.totalValue = this.totalExtraValue[j].total;
        }
      });
    });
  }

  extraPriceChanged(r: any, i: any, event: any) {
    let basePrice = Number(String(this.extraRow[r].baseCharge).replace(/,/g, ''));
    let qty = Number(String(this.extraRow[r].prices[i].qty).replace(/,/g, ''));
    let enteredPrice = Number(String(this.extraRow[r].prices[i].value).replace(/,/g, ''));

    if (!isNaN(basePrice) && !isNaN(qty) && !isNaN(enteredPrice)) {
      let expectedVal = basePrice * qty;
      let expectedStr = String(expectedVal).includes('.') ? expectedVal.toFixed(2) : String(expectedVal);
      this.extraRow[r].prices[i].individualCharge = (Number(expectedStr) !== enteredPrice);
    } else {
      this.extraRow[r].prices[i].individualCharge = true;
    }

    console.log(this.extraRow[r].prices[i])
    if (this.extraRow[r - 1]) {
      this.extraRow[r].prices[i].totalValue = Number(this.extraRow[r].prices[i].value) + Number(this.extraRow[r - 1].prices[i].totalValue);
    } else {
      this.extraRow[r].prices[i].totalValue = Number(this.extraRow[r].prices[i].value);
    }
    this.calculateExtraValue(true);
  }

}